import { BrowserRouter, Routes, Route, Link, NavLink, Navigate } from 'react-router-dom';
import MapPage from './pages/MapPage';
import SessionsPage from './pages/SessionsPage';
import SessionDetailPage from './pages/SessionDetailPage';
import StatsPage from './pages/StatsPage';
import ComparePage from './pages/ComparePage';

export default function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col bg-slate-950 text-slate-100" style={{ height: '100vh' }}>
        <header className="border-b border-slate-800 flex items-center px-4 gap-6 shrink-0" style={{ height: 56 }}>
          <Link to="/" className="text-white font-bold tracking-wider flex items-center gap-2">
            <span className="inline-block w-2.5 h-2.5 rounded-full bg-emerald-500" />
            DriveTest
          </Link>
          <nav className="flex gap-4 text-sm">
            <NavLink to="/" end className={navClass}>Map</NavLink>
            <NavLink to="/sessions" className={navClass}>Sessions</NavLink>
            <NavLink to="/compare" className={navClass}>Compare</NavLink>
            <NavLink to="/stats" className={navClass}>Stats</NavLink>
          </nav>
        </header>
        <main className="relative" style={{ flex: '1 1 0', minHeight: 0 }}>
          <Routes>
            <Route path="/" element={<MapPage />} />
            <Route path="/sessions" element={<SessionsPage />} />
            <Route path="/sessions/:id" element={<SessionDetailPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

function navClass({ isActive }: { isActive: boolean }): string {
  return [
    'px-2 py-1 rounded-md text-sm font-semibold uppercase tracking-wide',
    isActive ? 'text-emerald-400 border-b-2 border-emerald-400' : 'text-slate-400 hover:text-slate-200',
  ].join(' ');
}
